(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-selector-score/assets/javascripts/betslip-selector.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-selector-score/assets/javascripts/betslip-selector.js');
"use strict";

const BetslipCouponType = svs.components.tipsen.engine.constants.BetslipCouponType;
const useBetslipContext = svs.components.tipsen.betslipComponents.useBetslipContext;
const _svs$components$tipse = svs.components.tipsen.betslipSelectorScore.betslips,
  Standard = _svs$components$tipse.Standard,
  ExternaSystemspel = _svs$components$tipse.ExternaSystemspel;
const BetslipSelector = () => {
  const _useBetslipContext = useBetslipContext(),
    couponType = _useBetslipContext.couponType;
  let BetslipLocal;
  switch (couponType) {
    case BetslipCouponType.Standard:
      BetslipLocal = Standard;
      break;
    case BetslipCouponType.ExternaSystemspel:
      BetslipLocal = ExternaSystemspel;
      break;
    default:
      BetslipLocal = null;
      throw new Error("No betslip found for couponType: ".concat(couponType));
  }
  return React.createElement(BetslipLocal, null);
};
setGlobal('svs.components.tipsen.betslipSelectorScore.BetslipSelector', BetslipSelector);

 })(window);